<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="content soaclass">
    <div class="container">
        <div id="main">
            <div class="row">
                <div class="col-16">
                    <h1 class="medium">Scope of Sales Appointment Confirmation Form</h1>
                </div>
            </div>

            <div *ngIf ="currentYear">
            <div class="row">
                <div class="col-16">
                    <p>The Centers for Medicare and Medicaid Services requires agents to document the scope of a marketing appointment prior to any sales meeting to ensure understanding of what will be discussed between the agent and the Medicare beneficiary (or their authorized representative). All information provided on this form is confidential and should be completed by each person with Medicare or his/her authorized representative.</p>
                </div>
            </div>

            <div class="row">
                <div class="col-16">
                    <p><strong>Please initial below beside the type of product(s) you want the agent to discuss.</strong></p>
                </div>
                <button #focusableEleTop class="focusable-element"></button>
                <div class="col-16">
                    <div class="bottom-20" [ngClass]="{'input-error': PartDChecked }">
                        <div class="centered-label">
                            <input id="PartDChecked" type="text" name="PartDChecked" [(ngModel)]="beneficiarySoaViewEmailDetail.PartDChecked">
                            <label>Stand-alone Medicare Prescription Drug Plans (Part D)</label>
                        </div>
                        <div class="field-error-message">{{PartDChecked}}</div>
                    </div>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Prescription Drug Plan (PDP) -</strong> A stand-alone drug plan that adds prescription drug coverage to Original Medicare, some Medicare Cost Plans, some Medicare Private-Feefor- Service Plans, and Medicare Medical Savings Account Plans.</p>
                </div>
                <div class="col-16">
                    <div class="bottom-20" [ngClass]="{'input-error': PartCChecked }">
                        <div class="centered-label">
                            <input id="PartCChecked" type="text" name="PartCChecked" [(ngModel)]="beneficiarySoaViewEmailDetail.PartCChecked">
                            <label>Medicare Advantage Plans (Part C) and Cost Plans</label>
                        </div>
                        <div class="field-error-message">{{PartCChecked}}</div>
                    </div>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Health Maintenance Organization (HMO) -</strong> A Medicare Advantage Plan that provides all Original Medicare Part A and Part B health coverage and sometimes covers Part D prescription drug coverage. In most HMOs, you can only get your care from doctors or hospitals in the plan's network (except in emergencies).</p>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Preferred Provider Organization (PPO) Plan -</strong> A Medicare Advantage Plan that provides all Original Medicare Part A and Part B health coverage and sometimes covers Part D prescription drug coverage. PPOs have network doctors and hospitals but you can also use outof- network providers, usually at a higher cost.</p>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Private Fee-For-Service (PFFS) Plan -</strong> A Medicare Advantage Plan in which you may go to any Medicare-approved doctor, hospital and provider that accepts the plan's payment, terms and conditions and agrees to treat you - not all providers will. If you join a PFFS Plan that has a network, you can see any of the network providers who have agreed to always treat plan members. You will usually pay more to see out-of-network providers.</p>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Special Needs Plan (SNP) -</strong> A Medicare Advantage Plan that has a benefit package designed for people with special health care needs. Examples of the specific groups served include people who have both Medicare and Medicaid, people who reside in nursing homes, and people who have certain chronic medical conditions.</p>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Medical Savings Account (MSA) Plan -</strong> MSA Plans combine a high deductible health plan with a bank account. The plan deposits money from Medicare into the account. You can use it to pay your medical expenses until your deductible is met.</p>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Cost Plan -</strong> In a Medicare Cost Plan, you can go to providers both in and out of network. If you get services outside of the plan's network, your Medicare-covered services will be paid for under Original Medicare but you will be responsible for Medicare coinsurance and deductibles.</p>
                </div>
                <div class="col-16">
                    <p class="partition">
                        <strong>
                            By signing this form, you agree to a meeting with a sales agent to discuss the types
                            of products you initialed above.
                        </strong> Please note, the person who will discuss the products is either employed or contracted by a Medicare plan. They <u>do not</u> work directly for the Federal government. This individual may also be paid based on your enrollment in a plan.
                    </p>
                    <p>Signing this form does NOT obligate you to enroll in a plan, affect your current enrollment, or enroll you in a Medicare plan.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p><strong>Beneficiary or Authorized Representative Signature and Signature Date</strong></p>
                </div>
            </div>
            <button #focusableEleMid class="focusable-element"></button>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper" [ngClass]="{'input-error': BeneficiarySignature || BeneficiarySignatureSpecialCharacter }">
                        <label for="txtBeneficiarySignature">Signature</label>
                        <input name="txtBeneficiarySignature" type="text" id="txtBeneficiarySignature" placeholder="Signature" [(ngModel)]="beneficiarySoaViewEmailDetail.BeneficiarySignatureName">
                        <div class="field-error-message" *ngIf="BeneficiarySignature">{{BeneficiarySignature}}</div>
                        <div class="field-error-message" *ngIf="BeneficiarySignatureSpecialCharacter">{{BeneficiarySignatureSpecialCharacter}}</div>
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <label for="txtBeneficiarySigDate">Date</label>
                        <input name="txtBeneficiarySigDate" type="text" id="txtBeneficiarySigDate"
                                disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.BeneficiarySigDate">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p>If you are the authorized representative, please sign below:</p>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <label for="txtRepName">Representative's Name</label>
                        <input name="txtRepName" type="text" id="txtRepName" placeholder="Representative's Name" [(ngModel)]="beneficiarySoaViewEmailDetail.RepName">
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper wide" [ngClass]="{'input-error': BeneficiaryRelationShipError }">
                        <label for="repRelationShip">Your Relationship to the Beneficiary</label>
                        <select [(ngModel)]="beneficiarySoaViewEmailDetail.RepRelationship" id="repRelationShip" name="repRelationShip">
                            <option *ngFor="let reprel of repRelationShip" value={{reprel.text}}>
                                {{reprel.value}}
                            </option>
                        </select>
                        <div class="field-error-message" *ngIf="BeneficiaryRelationShipError">{{BeneficiaryRelationShipError}}</div>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-16">
                    <p class="required partition">All fields are required, unless marked as optional.</p>
                </div>
            </div>
            <fieldset>
                <legend>To be completed by Agent</legend>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <label for="txtAgentName">Agent Name</label>
                            <input name="txtAgentName" type="text" id="txtAgentName" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.AgentName">
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper">
                            <label for="txtAgentPhone">Agent Phone</label>
                            <input name="txtAgentPhone" type="text" id="txtAgentPhone" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.AgentPhone">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="input-wrapper">
                            <label for="txtAgentAddress">Agent Address</label>
                            <input name="txtAgentAddress" type="text" id="txtAgentAddress" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.AgentAddress">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <label for="txtBeneficiaryName">Beneficiary Name</label>
                            <input name="txtBeneficiaryName" type="text" id="txtBeneficiaryName" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.BeneficiaryName">
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper">
                            <label for="txtBeneficiaryPhone">Beneficiary Phone</label>
                            <input name="txtBeneficiaryPhone" type="text" id="txtBeneficiaryPhone" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.BeneficiaryPhone">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="input-wrapper">
                            <label for="txtBeneficiaryAddress">Beneficiary Address</label>
                            <input name="txtBeneficiaryAddress" type="text" id="txtBeneficiaryAddress" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.BeneficiaryAddress">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="input-wrapper">
                            <label for="txtMethodOfContact">Initial Method of Contact: (Indicate here if beneficiary was a walk-in.)</label>
                            <input name="txtMethodOfContact" type="text" id="txtMethodOfContact" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.ContactMethod">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="input-wrapper">
                            <label for="txtAgentSignature">Agent Signature</label>
                            <input name="txtAgentSignature" type="text" id="txtAgentSignature" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.AgentSignatureName">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <label for="txtPlans">Plan(s) the agent represented during this meeting</label>
                            <textarea name="txtPlans" rows="3" cols="20" maxlength="500" id="txtPlans" class="ckValidate textMultiline"
                                        disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.Plan"></textarea>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <label for="txtDateOfAppointment">Date of Appointment</label>
                            <input name="txtDateOfAppointment" type="text" id="txtDateOfAppointment" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.ApplicationDate">
                        </div>
                    </div>
                </div>
            </fieldset>

            <div class="row">
                <div class="col-16">
                    <h2>Instructions for agents</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p>If you are doing a sales presentation to a beneficiary, you <strong>MUST</strong> have a documented scope of what you will be discussing with the beneficiary prior to the appointment. A beneficiary cannot agree to the scope over the phone and sign the documentation later. Documentation must be in writing in the form of a signed document by the beneficiary. You must send this documentation with the enrollment form to {{insuranceCompany}}</p>
                    <p><small>* Scope of Appointment documentation is subject to CMS record retention requirements *</small> </p>

                    <p>If the form was signed by the beneficiary at time of appointment, provide explanation why SOA was not documented prior to meeting</p>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <div class="bottom-20">
                        <textarea name="txtWhyNoDocs" rows="3" cols="20" id="txtWhyNoDocs" class="textMultiline" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.Instructions"></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p>{{insuranceCompanyShortName}} is a Prescription Drug Plan with a Medicare contract offered by {{insuranceCompany}}. Enrollment in {{insuranceCompanyShortName}} depends on contract renewal.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <div class="input-wrapper">
                        <input name="txtBeneficiaryEmailAddress" type="text" id="txtBeneficiaryEmailAddress" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.BeneficiaryEmail">
                    </div>
                </div>
            </div>
            </div>
            <div *ngIf="nextYear">
                <div>
                    <div class="row">
                        <div class="col-16">
                            <p>This form is required prior to a one-on-one marketing appointment to ensure understanding of what will be discussed between the agent and the Medicare beneficiary (or their authorized representative). All information provided on this form is confidential and should be completed by each person with Medicare or his/her authorized representative.</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-16">
                            <p><strong>Please place a check mark in the box next to the of product(s) you want the agent to discuss.</strong> (See helpful descriptions on the next page.)</p>
                        </div>
                        <button #focusableEleTop class="focusable-element"></button>
                        <div class="col-16" [ngClass]="{'input-error': PartDChecked }">
                            <div class="bottom-20" >
                                <div class="centered-label">
                                    <input type="checkbox" id="PartDChecked" name="PartDChecked" [checked]="PartDCheckedValue" (change)="PartDCheckedValue = !PartDCheckedValue" /><!--[(ngModel)]="beneficiarySoaViewEmailDetail.PartDChecked">-->
                                    <label for="PartDChecked">Stand-alone Medicare Prescription Drug Plans (Part D)</label>
                                </div>
                            </div>
                            <div class="field-error-message">{{PartDChecked}}</div>
                        </div>
                        <div class="col-16">
                            <div class="bottom-20" [ngClass]="{'input-error': PartCChecked }">
                                <div class="centered-label">
                                    <input type="checkbox" id="PartCChecked" name="PartCChecked" [checked]="PartCCheckedValue" (change)="PartCCheckedValue = !PartCCheckedValue" /> <!--[(ngModel)]="beneficiarySoaViewEmailDetail.PartCChecked">-->
                                    <label for="PartCChecked">Medicare Advantage Plans (Part C) and Cost Plans</label>
                                </div>
                                <div class="field-error-message">{{PartCChecked}}</div>
                            </div>
                        </div>
                        <div class="col-16">
                            <p>Medicare Health Maintenance Organization (HMO), Medicare Preferred Provider Organization (PPO) Plan, Medicare Private Fee-For-Service (PFFS) Plan, Medicare Special Needs Plan (SNP), Medicare Medical Savings Account (MSA) Plan, or Medicare Cost Plan</p>
                        </div>
                        <div class="col-16">
                            <div class="bottom-20" [ngClass]="{'input-error': OtherChecked }">
                                <div class="centered-label">
                                    <input type="checkbox"id="OtherChecked" name="OtherChecked" [checked]="OtherCheckedValue" (change)="OtherCheckedValue = !OtherCheckedValue" /><!--[(ngModel)]="beneficiarySoaViewEmailDetail.OtherChecked">-->
                                    <label for="OtherChecked">Other Plans</label>
                                </div>
                                <div class="field-error-message">{{OtherChecked}}</div>
                            </div>
                        </div>
                        <div class="col-16">
                            <p>Dental/Vision/Hearing Products, Supplemental Health Products, Medicare Supplement (Medigap) Products</p>
                        </div>
                        <div class="col-16">
                            <p>Signing this form does NOT obligate you to enroll in a plan, affect your current or future Medicare enrollment status, or automatically enroll you in the plan(s) discussed.</p>
                        </div>
                    
                    </div>
                    <div class="row">
                        <div class="col-16">
                            <p><strong>Beneficiary or Authorized Representative Signature and Signature Date:</strong></p>
                        </div>
                    </div>
                    <button #focusableEleMid class="focusable-element"></button>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper" [ngClass]="{'input-error': BeneficiarySignature || BeneficiarySignatureSpecialCharacter }">
                                <label for="txtBeneficiarySignature">Signature</label>
                                <input name="txtBeneficiarySignature" type="text" id="txtBeneficiarySignature" placeholder="Signature" [(ngModel)]="beneficiarySoaViewEmailDetail.BeneficiarySignatureName">
                                <div class="field-error-message" *ngIf="BeneficiarySignature">{{BeneficiarySignature}}</div>
                                <div class="field-error-message" *ngIf="BeneficiarySignatureSpecialCharacter">{{BeneficiarySignatureSpecialCharacter}}</div>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="input-wrapper">
                                <label for="txtBeneficiarySigDate">Date</label>
                                <input name="txtBeneficiarySigDate" type="text" id="txtBeneficiarySigDate"
                                        disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.BeneficiarySigDate">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-16">
                            <p>If you are the authorized representative, please sign above and print below:</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <label for="txtRepName">Representative's Name</label>
                                <input name="txtRepName" type="text" id="txtRepName" placeholder="Representative's Name" [(ngModel)]="beneficiarySoaViewEmailDetail.RepName">
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="input-wrapper wide" [ngClass]="{'input-error': BeneficiaryRelationShipError }">
                                <label for="repRelationShip">Your Relationship to the Beneficiary</label>
                                <select [(ngModel)]="beneficiarySoaViewEmailDetail.RepRelationship" id="repRelationShip" name="repRelationShip">
                                    <option *ngFor="let reprel of repRelationShip" value={{reprel.text}}>
                                        {{reprel.value}}
                                    </option>
                                </select>
                                <div class="field-error-message" *ngIf="BeneficiaryRelationShipError">{{BeneficiaryRelationShipError}}</div>
                            </div>
                        </div>
                    </div>

                    <fieldset>
                        <legend>To be completed by Agent:</legend>
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <label for="txtAgentName">Agent Name</label>
                                    <input name="txtAgentName" type="text" id="txtAgentName" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.AgentName">
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <label for="txtAgentPhone">Agent Phone</label>
                                    <input name="txtAgentPhone" type="text" id="txtAgentPhone" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.AgentPhone">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-16">
                                <div class="input-wrapper">
                                    <label for="txtAgentAddress">Agent Address</label>
                                    <input name="txtAgentAddress" type="text" id="txtAgentAddress" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.AgentAddress">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <label for="txtBeneficiaryName">Beneficiary Name</label>
                                    <input name="txtBeneficiaryName" type="text" id="txtBeneficiaryName" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.BeneficiaryName">
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <label for="txtBeneficiaryPhone">Beneficiary Phone</label>
                                    <input name="txtBeneficiaryPhone" type="text" id="txtBeneficiaryPhone" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.BeneficiaryPhone">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-16">
                                <div class="input-wrapper">
                                    <label for="txtBeneficiaryAddress">Beneficiary Address</label>
                                    <input name="txtBeneficiaryAddress" type="text" id="txtBeneficiaryAddress" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.BeneficiaryAddress">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-16">
                                <div class="input-wrapper">
                                    <label for="txtMethodOfContact">Initial Method of Contact: (Indicate here if beneficiary was a walk-in.)</label>
                                    <input name="txtMethodOfContact" type="text" id="txtMethodOfContact" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.ContactMethod">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-16">
                                <div class="input-wrapper">
                                    <label for="txtAgentSignature">Agent Signature</label>
                                    <input name="txtAgentSignature" type="text" id="txtAgentSignature" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.AgentSignatureName">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-16">
                                <div class="bottom-20">
                                    <label for="txtPlans">Plan(s) the agent represented during this meeting</label>
                                    <textarea name="txtPlans" rows="3" cols="20" maxlength="500" id="txtPlans" class="ckValidate textMultiline"
                                                disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.Plan"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-16">
                                <div class="bottom-20">
                                    <label for="txtDateOfAppointment">Date of Appointment</label>
                                    <input name="txtDateOfAppointment" type="text" id="txtDateOfAppointment" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.ApplicationDate">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-16">
                                <div class="bottom-20">
                                    <label for="whyNoDocs">Provide explanation why SOA was not documented prior to meeting (if applicable)</label>
                                    <textarea name="txtWhyNoDocs" rows="3" cols="20" id="txtWhyNoDocs" class="textMultiline" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.Instructions"></textarea>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <div class="row">
                        <div class="col-16">
                            <!--<p>ATENCIÓN: Si usted habla español u otros idiomas, tenemos servicios de asistencia lingüística disponibles para usted sin costo alguno. Llame al 1-866-235-5660 (TTY: 711)</p>-->
                            <p>{{insuranceCompanyShortName}} is a Prescription Drug Plan with a Medicare contract offered by {{insuranceCompany}}. Enrollment in {{insuranceCompanyShortName}} depends on contract renewal.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-16">
                            <div class="input-wrapper">
                                <input name="txtBeneficiaryEmailAddress" type="text" id="txtBeneficiaryEmailAddress" disabled="disabled" [(ngModel)]="beneficiarySoaViewEmailDetail.BeneficiaryEmail">
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <div class="col-16">
                            <h1>Helpful Terms</h1>
                        </div>
                        <div class="col-16">
                            <p> <strong> <u>Stand-alone Medicare Prescription Drug Plans (Part D) </u> </strong></p>
                        </div>
                        <div class="col-16">
                            <p> A stand-alone drug plan that adds prescription drug coverage to Original Medicare, some Medicare Cost Plans, some Medicare Private-Fee-for-Service Plans, and Medicare Medical Savings Account Plans.</p>
                        </div>
                        <div class="col-16">
                            <p><strong> <u>Medicare Advantage Plans (Part C) and Cost Plans </u></strong></p>
                        </div>
                        <div class="col-16">
                            <p><strong>Medicare Health Maintenance Organization (HMO) -</strong> A Medicare Advantage Plan that provides all Original Medicare Part A and Part B health coverage and sometimes covers Part D prescription drug coverage. In most HMOs, you can only get your care from doctors or hospitals in the plan's network (except in emergencies).</p>
                        </div>
                        <div class="col-16">
                            <p><strong>Medicare Preferred Provider Organization (PPO) Plan -</strong> A Medicare Advantage Plan that provides all Original Medicare Part A and Part B health coverage and sometimes covers Part D prescription drug coverage. PPOs have network doctors and hospitals but you can also use outof- network providers, usually at a higher cost.</p>
                        </div>
                        <div class="col-16">
                            <p><strong>Medicare Private Fee-For-Service (PFFS) Plan -</strong> A Medicare Advantage Plan in which you may go to any Medicare-approved doctor, hospital and provider that accepts the plan's payment, terms and conditions and agrees to treat you - not all providers will. If you join a PFFS Plan that has a network, you can see any of the network providers who have agreed to always treat plan members. You will usually pay more to see out-of-network providers.</p>
                        </div>
                        <div class="col-16">
                            <p><strong>Medicare Special Needs Plan (SNP) -</strong> A Medicare Advantage Plan that has a benefit package designed for people with special healthcare needs. Examples of the specific groups served include people who have both Medicare and Medicaid, people who reside in nursing homes, and people who have certain chronic medical conditions.</p>
                        </div>
                        <div class="col-16">
                            <p><strong>Medicare Medical Savings Account (MSA) Plan -</strong> MSA Plans combine a high deductible health plan with a bank account. The plan deposits money from Medicare into the account. You can use it to pay your medical expenses until your deductible is met.</p>
                        </div>
                        <div class="col-16">
                            <p><strong>Medicare Cost Plan -</strong> In a Medicare Cost Plan, you can go to providers both in and out of network. If you get services outside of the plan's network, your Medicare-covered services will be paid for under Original Medicare but you will be responsible for Medicare coinsurance and deductibles.</p>
                        </div>
                        <div class="col-16">
                            <p><strong>Med Supp -</strong> Plans offering a supplemental policy to fill "gaps" in Original Medicare coverage. A Medigap policy typically pays some or all of the deductible and coinsurance amounts applicable to Medicare-covered services, and sometimes covers items and services that are not covered by Medicare, such as care outside of the country. These plans are not affiliated or connected to Medicare.</p>
                        </div>
                        <div class="col-16">
                            <p><strong>Supplemental Health Products -</strong> Plans offering additional benefits; payable to consumers based upon their medical utilization; sometimes used to defray copays/coinsurance. These plans are not affiliated or connected to Medicare</p>
                        </div>
                        <div class="col-16">
                            <p><strong>Dental/Vision/Hearing Products -</strong> Plans offering additional benefits for consumers who are looking to cover needs for dental, vision or hearing. These plans are not affiliated or connected to Medicare.</p>
                        </div>
                    </div>
                        <div class="row">
                            <div class="col-16">
                                <h2 class="partition">Agent Instructions</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-16">
                                <p>If you are doing a sales presentation to a beneficiary, you MUST have a documented scope of what you will be discussing with the beneficiary prior to the appointment. A beneficiary cannot agree to the scope over the phone and sign the documentation later. Documentation must be in writing in the form of a signed document by the beneficiary. If you are sending an enrollment form for a client to {{insuranceCompany}}, you must also send this document, signed by the client, to {{insuranceCompanyShortName}} as well. </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-16">
                                <p class="partition">Please note, the person who will discuss the products is either employed or contracted by a Medicare plan. They do not work directly for the federal government. This individual may also be paid based on your enrollment in a plan.</p>
                            </div>
                        </div>
                    </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <button id="returnToAgent" class="button cancel" (click)="returnToAgent(beneficiarySoaViewEmailDetail)">Return to Agent</button>
                </div>
            </div>
        </div>
    </div>
</div>
       
